<template>
  <div class="poi-picker">
    <rich-button
      class="poi-picker-btn"
      :disabled="disabled"
      @click="showPopup"
      outline
    >{{showValue}}</rich-button>
  </div>
</template>

<script type="text/ecmascript-6">
import { getBDLocale, i18n } from '@/common/utils/i18n'
import { mapGetters } from 'vuex'

// 不走vue数据响应
let tempGeo = null
export default {
  name: 'PoiPicker',
  inject: ['rootForm'],
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    value: {
      type: Object,
      required: true
    },
    addrKey: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: i18n.gettext('校准POI')
    }
  },
  data () {
    return {
      // map instance
      map: null,
      showMap: false,
      currentGeo: {},
      language: getBDLocale(),
      zoom: 13,
      loadingToast: null
    }
  },
  computed: {
    ...mapGetters(['geo']),
    showValue () {
      return (this.value.lng && this.value.lat)
        ? this.gettext('已校准')
        : this.gettext('点击校准')
    }
  },
  methods: {
    showPopup () {
      const FullScreenPoiPicker = this.$createFullScreenPoiPicker({
        value: this.value,
        addrKey: this.addrKey,
        title: this.title
      }).show()
      FullScreenPoiPicker.$on('confirm', (data) => {
        this.$emit('input', data)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  .poi-picker {
    &-btn {
      padding: 10Px;
      text-align: left;
      color: $color-light-grey;
      font-size: $fontsize-medium;
    }
    ::v-deep .rich-btn-outline:after {
      border: none;
    }
    .panel-wrap {
      width: 100%;
      position: absolute;
      top: 60Px;
      bottom: 0;
      overflow: hidden;
    }
    .locate-btn {
      position: absolute;
      left: 10Px;
      bottom: 24Px;
      width: 30Px;
      height: 30Px;
      background: #FFF;
      z-index: 99;
      text-align: center;
      i {
        line-height: 30Px;
        font-size: 22Px;
      }
    }
  }
</style>
